import NovidadesPage from "@/Pages/Novidades/NovidadesPage.vue";
import store from "@/store";

export default [
  {
    path: "/novidades",
    name: "novidades",
    component: NovidadesPage,
    beforeEnter(to, from, next) {
      const user = store.getters["Auth/user"];
      const roles = user?.roles || [];
      const roleName = user?.roleName || "";
      const isSuperAdmin =
        roles.some((r) => r.name === "super-admin") || roleName === "super-admin";

      if (!isSuperAdmin) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
];
